import { createFileRoute } from '@tanstack/react-router';

import { RolesPage } from '@/features/admin/roles/RolesPage';

export const Route = createFileRoute('/_protected/t/$tenantId/admin/roles/roles')({
  component: RolesPage,
});
